module.exports = __webpack_public_path__ + "static/positive-discipline-az-1426a87930a08f287fdcdaab20b94ccd.jpg";